export default __webpack_public_path__ + "static/media/Gellix-Light.0c2e3649.woff";